"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const music_visualization_1 = require("./music-visualization");
const types_1 = require("./types");
class Form extends music_visualization_1.MusicVisualization {
    constructor(element, onClick) {
        super(element, { top: 0, bottom: 12, left: 35, right: 0 }, true, true, false, onClick);
    }
    //TODO NEEDS TO BE WORKED ON!!! INVERTED Y AXIS VALUES ETC...
    updateDataRepresentation() {
        this.addNodeShapes(types_1.Ellipse);
        this.addNodeLabels();
    }
    ;
}
exports.Form = Form;



//////////////////
// WEBPACK FOOTER
// ./~/music-visualization/lib/form.js
// module id = 1745
// module chunks = 3